import { useState } from "react";
import SectionCard from "./SectionCard";

function ReadMore({ text, limit = 300 }) {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  // Preserve line breaks from API
  const formatted = text.replace(/\n/g, "\n");
  const isLong = formatted.length > limit;
  const display = !isLong || expanded ? formatted : formatted.slice(0, limit) + "…";

  return (
    <div style={{ fontSize: 13, color: "var(--fc-text-muted)", lineHeight: 1.7, margin: "6px 0 0", whiteSpace: "pre-line" }}>
      {display}
      {isLong && (
        <button onClick={() => setExpanded(e => !e)}
          style={{ background: "none", border: "none", cursor: "pointer", color: "var(--fc-blue)", fontWeight: 600, fontSize: 12, padding: "0 0 0 6px", fontFamily: "inherit" }}>
          {expanded ? "Show less" : "Read more"}
        </button>
      )}
    </div>
  );
}

export default function ExperienceTab({ candidate }) {
  const items = candidate.experience || [];

  if (!items.length) {
    return (
      <SectionCard title="Work Experience">
        <div style={{ textAlign: "center", padding: "24px 0" }}>
          <div style={{ width: 44, height: 44, borderRadius: 12, background: "var(--fc-border-light)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 10px" }}>
            <i className="fa-solid fa-briefcase" style={{ fontSize: 18, color: "var(--fc-text-hint)" }} />
          </div>
          <p style={{ color: "var(--fc-text-subtle)", fontSize: 13, margin: 0 }}>No work experience added yet.</p>
        </div>
      </SectionCard>
    );
  }

  return (
    <SectionCard title="Work Experience">
      {items.map((exp, i) => (
        <div key={i} style={{
          paddingBottom: i < items.length - 1 ? 20 : 0,
          marginBottom:  i < items.length - 1 ? 20 : 0,
          borderBottom:  i < items.length - 1 ? "1px solid var(--fc-border-light)" : "none",
        }}>
          <div className="d-flex gap-3">
            {/* Icon */}
            <div style={{ flexShrink: 0 }}>
              <div style={{ width: 42, height: 42, borderRadius: 11, background: "var(--fc-green-light)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className="fa-solid fa-briefcase" style={{ color: "#16A34A", fontSize: 16 }} />
              </div>
            </div>

            {/* Content */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8, flexWrap: "wrap" }}>
                <div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: "var(--fc-text-primary)", lineHeight: 1.3 }}>{exp.title}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "var(--fc-blue)", marginTop: 2 }}>
                    {exp.company}{exp.location ? ` · ${exp.location}` : ""}
                  </div>
                </div>
                {exp.isCurrent && (
                  <span style={{ fontSize: 10, fontWeight: 700, padding: "3px 9px", borderRadius: 99, background: "var(--fc-green-light)", color: "var(--fc-green-text)", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Current
                  </span>
                )}
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}>
                <i className="fa-regular fa-calendar" style={{ fontSize: 10, color: "var(--fc-text-subtle)" }} />
                <span style={{ fontSize: 12, color: "var(--fc-text-subtle)", fontWeight: 500 }}>{exp.period || "Period not set"}</span>
              </div>

              <ReadMore text={exp.desc} />
            </div>
          </div>
        </div>
      ))}
    </SectionCard>
  );
}
